import type { RootState } from 'typesafe-actions';

export const getIsBot = (state: RootState) => state.isBot;
